import React, { useEffect } from 'react';
import { useParams } from '@thd-olt-component-react/router';
import { StoreFinderRedirector } from '@thd-nucleus/app-render';
import {
  extend,
  QueryContext
} from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { StateDirectory, StateServices } from '@thd-olt-component-react/store-directory';
import { Metadata, StateDirectoryMetadata } from '@thd-olt-component-react/metadata';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { StoreFinderBreadcrumbs } from '../../shared-components/StoreFinderBreadcrumbs';

export const StateDirectoryService = () => {
  declareContexts([QueryContext, ExperienceContext], { freeze: true });
  const { state } = useParams();

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-finder.state-directory-page-load', { state });
  }, [state]);

  return (
    <>

      <ErrorBoundary name="sf-stateDirectory-redirector">
        <StoreFinderRedirector />
      </ErrorBoundary>
      <ErrorBoundary name="state-directory-metadata">
        <Metadata>
          <StateDirectoryMetadata state={state} />
        </Metadata>
      </ErrorBoundary>
      <div className="sui-max-w-screen-2xl sui-m-auto">
        <div className="sui-px-2 2xl:sui-px-0 sui-pt-2">
          <ErrorBoundary name="state-directory-breadcrumbs">
            <StoreFinderBreadcrumbs pageName={state} />
          </ErrorBoundary>
          <ErrorBoundary name="state-directory-content">
            <div className="sui-mt-2">
              <StateDirectory state={state} />
              <StateServices state={state} />
            </div>
          </ErrorBoundary>
        </div>
      </div>
    </>
  );
};

StateDirectoryService.displayName = 'StateDirectory';
StateDirectoryService.propTypes = {
};

StateDirectoryService.dataModel = extend({},
  StateDirectory,
  StateServices,
  StoreFinderBreadcrumbs,
  StateDirectoryMetadata,
  StoreFinderRedirector
);
